const A11yDialog = require('./a11ydialog')

const dialogElement = document.querySelector("#a11y-dialog");

if (dialogElement !== null) {
    const dialog = new A11yDialog(dialogElement)

    const dialogTitle = document.querySelector("#a11y-dialog__title")
    const dialogContent = document.querySelector("#a11y-dialog__content")
    const dialogImg = document.querySelector("#a11y-dialog__img")

    document.querySelectorAll("a[data-a11y-dialog-show='a11y-dialog']").forEach((item) => {
        ((button) => {
            button.addEventListener("click", () => {
                dialogTitle.innerHTML = button.dataset.dialogTitle
                dialogContent.innerHTML = button.dataset.dialogContent
                dialogImg.innerHTML = button.dataset.dialogImg ? button.dataset.dialogImg : ""
                dialog.show()
            });
        })(item)
    })
}




// WEBPACK FOOTER //
// ./src/js/dialogs.js